import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export function SuccessPage() {
  const { language } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    // Auto redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#07060B] flex items-center justify-center px-4" data-testid="success-page">
      <div className="neon-card-glow text-center py-12 max-w-md w-full">
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#27D7FF] to-[#8B5CFF] flex items-center justify-center mx-auto mb-6 animate-pulse-glow">
          <Check className="w-10 h-10 text-white" />
        </div>
        <h1 className="font-heading text-3xl font-bold text-[#F4F2FF] mb-3">
          {language === 'en' ? 'Success!' : '¡Éxito!'}
        </h1>
        <p className="text-[#A7A3BA] mb-6">
          {language === 'en' 
            ? 'Your submission has been received. We will be in touch soon.'
            : 'Tu solicitud ha sido recibida. Te contactaremos pronto.'}
        </p>
        <p className="text-[#8B5CFF] text-sm">
          {language === 'en' ? 'Redirecting to home...' : 'Redirigiendo al inicio...'}
        </p>
      </div>
    </div>
  );
}

export default SuccessPage;
